import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import SortableList from '../reorderCustomViewsDND/SortableList';
import { CUSTOM_VIEW } from '../constants/dragAndDropTypes';
import UIIcon from 'UIComponents/icon/UIIcon';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { AccordionState, useCustomViewAccordion } from '../hooks/useCustomViewAccordion';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Carat = styled(UIIcon).withConfig({
  displayName: "PermissionsViewLinksList__Carat",
  componentId: "ftenhs-0"
})(["color:", ";transform:", ";transition:transform 150ms ease;"], CALYPSO_DARK, ({
  open
}) => open && 'rotate(90deg)');
const Header = styled.div.withConfig({
  displayName: "PermissionsViewLinksList__Header",
  componentId: "ftenhs-1"
})(["display:flex;justify-content:space-between;align-items:center;cursor:pointer;padding:8px 24px 8px 12px;width:100%;font-weight:600 !important;transition:color 150ms ease;:hover{color:", ";}"], CALYPSO_DARK);
const PermissionsViewLinksList = ({
  views,
  createNavLinkFromView,
  header,
  listName,
  currentViewId,
  loading,
  onSort,
  storageKey
}) => {
  const [accordionState, toggleAccordionState] = useCustomViewAccordion({
    views,
    currentViewId,
    storageKey
  });
  if (!views.length) {
    return null;
  }
  const isOpen = accordionState === AccordionState.OPEN;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Header, {
      className: "m-top-3 p-left-3",
      onClick: toggleAccordionState,
      children: [header, /*#__PURE__*/_jsx(Carat, {
        name: "right",
        open: isOpen
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      renderContent: () => /*#__PURE__*/_jsx(SortableList, {
        listId: `user-generated-views-list-${listName}`,
        listItemType: CUSTOM_VIEW,
        loading: loading,
        onSort: onSort,
        children: views.map(createNavLinkFromView)
      }),
      open: isOpen
    })]
  });
};
PermissionsViewLinksList.displayName = 'PermissionsViewLinksList';
export default PermissionsViewLinksList;